import React, { useEffect, useState } from 'react';
import styles from './ScrollButton.module.scss';
import { smoothScrollingToAnchor } from 'app/utils';
import { Button } from '@zurich-primitives/button';
import { getService, useAppSelector } from 'app/redux';
import { ReactComponent as ScrollDownIcon } from 'app/assets/Icons/CollapseDownWhite.svg';

export const ScrollButton: React.FC<{ hideLetsTry?: boolean }> = ({
  hideLetsTry = false
}) => {
  const [isAtLetsTry, setIsAtLetsTry] = useState(false);
  const currentService = useAppSelector(getService);

  const handleClick = (): void => {
    smoothScrollingToAnchor('letstry');
  };

  useEffect(() => {
    setIsAtLetsTry(false);
  }, [currentService]);

  const callBackFunction: IntersectionObserverCallback = (entries) => {
    const entry = entries[0];
    setIsAtLetsTry(entry.isIntersecting);
  };

  const options: IntersectionObserverInit = {
    root: null,
    threshold: 0.1
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callBackFunction, options);

    const letsTrySection = document.getElementById('letstry');
    if (letsTrySection) {
      observer.observe(letsTrySection);
    }

    return () => {
      if (letsTrySection) {
        observer.unobserve(letsTrySection);
      }
    };
  }, []);

  return (
    <>
      {!isAtLetsTry && (
        <Button
          onClick={handleClick}
          className={hideLetsTry ? styles['hide-btn'] : styles['btn-shine']}
          size="small"
          variant="secondary"
        >
          <Button.Icon>
            <ScrollDownIcon />
          </Button.Icon>
          <Button.Label>Let&apos;s try it</Button.Label>
        </Button>
      )}
    </>
  );
};
